import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-redmonk-wellness', 
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './redmonk-wellness.html',
  styleUrl: './redmonk-wellness.css',
})
export class RedmonkWellness {

}
